const serviceheader=()=>{
    return(
        <>
            <div className="container-fluid">
                <div className="container p-0 servicehero d-flex justify-content-center align-items-center">
                    
                </div>

                <h1 className="display-1 mobileTextheader" style={{position:'absolute', color:'#ffffff', marginLeft:'550px', marginTop:'-370px', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>ABOUT US</h1>
            </div>
        </>
    )
}


export default serviceheader